export const carouselSettings = {
  fixedWidth: '310px',
  gap: '12px',
  pagination: false,
}
